import * as fb from '@/plugins/firebase'
export const state = {
    questions: [],
}

export const mutations = {
    setQuestions(state, newValue) {
        state.questions = newValue
    },
}

export const actions = {

    async saveQuestionsOrder({dispatch}, campaignId) {

        let saveQuestion = (question) => {

            fb.campaignsCollection.doc(campaignId).collection(fb.COLLECTION_PATH.QUESTIONS).doc(question.id).update({order: question.order})
        }

        let allUpdates = state.questions.map(saveQuestion);

        await Promise.all(allUpdates)

        dispatch('loadQuestions', campaignId)

    },
    async saveQuestion({dispatch}, params) {

        let question = params.question
        let questionRef = null;
        let answers = question.answers

        delete question['answers']

        if (question.id) {
            await fb.campaignsCollection.doc(params.campaignId).collection(fb.COLLECTION_PATH.QUESTIONS).doc(question.id).set(question)
        } else {
            question.order = state.questions ? state.questions.length + 1 : 1;
            questionRef = await fb.campaignsCollection.doc(params.campaignId).collection(fb.COLLECTION_PATH.QUESTIONS).add(question)
            question.id = questionRef.id
        }
        console.log('question answers', question, answers)

        if (question.id && answers) {
            answers.forEach((a, index) => {
                a.order = index + 1
            })

            let saveAnswer = async (a) => {
                let objToSave = Object.assign({}, a)
                delete objToSave['file']
                delete objToSave['url']

                if (a.id) {
                    await fb.campaignsCollection.doc(params.campaignId).collection(fb.COLLECTION_PATH.QUESTIONS)
                        .doc(question.id).collection(fb.COLLECTION_PATH.ANSWERS).doc(a.id).set(objToSave);
                } else {
                    let aref = await fb.campaignsCollection.doc(params.campaignId).collection(fb.COLLECTION_PATH.QUESTIONS)
                        .doc(question.id).collection(fb.COLLECTION_PATH.ANSWERS).add(objToSave);
                    a.id = aref.id
                }

                return a
            }

            let answersUpdate = await Promise.all(answers.map(saveAnswer))
            let uploadAnswer = (answer) => {
                if (answer.file) {
                    fb.storage.ref(`${fb.COLLECTION_PATH.CAMPAIGNS}/${params.campaignId}/${questionRef.id}/${answer.id}`).put(answer.file);
                } else {
                    return Promise.resolve();
                }
            }

            await Promise.all(answersUpdate.map(uploadAnswer))

            dispatch('loadQuestions', params.campaignId)
        }

        return questionRef

    },
    async deleteQuestion({dispatch}, params) {

        let question = params.question

        if (question.id) {
            await fb.campaignsCollection.doc(params.campaignId).collection(fb.COLLECTION_PATH.QUESTIONS).doc(question.id).delete()
        }

        dispatch('loadQuestions', params.campaignId)

    },

}

export default {
    state,
    actions,
    mutations,
};
